<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" sm="2">
        <v-card tile elevation="0" outlined>
          <v-card-title class="justify-center site-card-title-bg pb-3">
            <p class="ma-0">발전정보</p>
          </v-card-title>
          <v-card-text>
            <v-list dense class="mt-6">
              <v-list-item-title class="title">PV PLANT</v-list-item-title>
              <v-divider style="border-width: 2px"></v-divider>
              <v-list-item>
                <v-list-item-content>전월발전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{PVPCS.PVPCS_AfterMonth_P}} MVh</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>당월발전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{PVPCS.PVPCS_CurrentMonth_P}} MVh</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>누적발전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{PVPCS.PVPCS_CurrentMonth_P}} MVh</v-list-item-content>
              </v-list-item>
              <v-list-item v-show="false">
                <v-list-item-content>당월발전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{PVPCS.PVPCS_TotalOP_P_L}} MVh</v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list dense class="mt-6">
              <v-list-item-title class="title">ESS</v-list-item-title>
              <v-divider style="border-width: 2px"></v-divider>
              <v-list-item>
                <v-list-item-content>전월방전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{EPCS.EPCS_AfterMonth_P}} MVh</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>당월방전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{EPCS.EPCS_CurrentMonth_P}} MVh</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>누적방전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{EPCS.EPCS_Current_P}} MVh</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="2">
        <v-card tile elevation="0" outlined>
          <v-card-title class="justify-center flex-column site-card-title-bg pt-2 pb-0">
            태양광인버터
            <p class="text-caption ma-0">현재발전량(출력전력)</p>
          </v-card-title>
          <v-card-text>
            <work-state-chart :value="PVPCS.PVPCS_Pac"></work-state-chart>
            <v-list dense class="mt-6">
              <v-list-item-subtitle class="text-center text-h6">&nbsp;</v-list-item-subtitle>
              <v-list-item-title
                class="text-h4 font-weight-bold text-center pb-4 txt-blue"
              >{{PVPCS.PVPCS_Pac}} kW</v-list-item-title>
              <v-divider style="border-width: 2px;"></v-divider>
              <v-list-item v-show="false">
                <v-list-item-content>입력전력</v-list-item-content>
                <v-list-item-content class="justify-end">{{PVPCS.PVPCS_Pdc}} kW</v-list-item-content>
              </v-list-item>
              <v-list-item v-show="false">
                <v-list-item-content>출력전력</v-list-item-content>
                <v-list-item-content class="justify-end">{{PVPCS.PVPCS_Pac}} kW</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>일간누적발전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{PVPCS.PVPCS_DailyP}} kWh</v-list-item-content>
              </v-list-item>
              <v-list-item v-show="false">
                <v-list-item-content>일간누적시간</v-list-item-content>
                <v-list-item-content class="justify-end">{{PVPCS.PVPCS_DailyH}} kW</v-list-item-content>
              </v-list-item>
              <v-list-item v-show="false">
                <v-list-item-content>총누적발전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{PVPCS.PVPCS_TotalP}} MWh</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="2">
        <v-card tile elevation="0" outlined>
          <v-card-title class="justify-center flex-column site-card-title-bg pt-2 pb-0">
            ESS PCS
            <p class="text-caption ma-0">현재충*방전력</p>
          </v-card-title>
          <v-card-text class="pb-16">
            <work-state-chart :value="EPCS.EPCS_ActPower"></work-state-chart>
            <v-list dense class="mt-6">
              <v-list-item-subtitle
                class="text-center text-h6"
              >{{EPCS.EPCS_CDStatus_NAME || '&nbsp;'}}</v-list-item-subtitle>
              <v-list-item-title
                class="text-h4 font-weight-bold text-center pb-4 txt-blue"
              >{{EPCS.EPCS_ActPower}} kW</v-list-item-title>
              <v-divider style="border-width: 2px;"></v-divider>
              <v-list-item v-show="false">
                <v-list-item-content>입력전력</v-list-item-content>
                <v-list-item-content class="justify-end">{{EPCS.EPCS_DCPower}} kW</v-list-item-content>
              </v-list-item>
              <v-list-item v-show="false">
                <v-list-item-content>출력전력</v-list-item-content>
                <v-list-item-content class="justify-end">{{EPCS.EPCS_ActPower}} kW</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>일간누적방전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{EPCS.EPCS_DayDisEnergy}} kWh</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>일간누적충전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{EPCS.EPCS_DayChaEnergy}} kWh</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>총누적충전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{EPCS.EPCS_TotChaEnergy}} MWh</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>총누적방전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{EPCS.EPCS_TotDisEnergy}} kWh</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-text class="d-flex flex-column">
            <v-card-subtitle class="pt-0">운행정보</v-card-subtitle>
            <img class="align-self-center" :src="trafficLight" alt>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="2">
        <v-card tile elevation="0" outlined>
          <v-card-title class="justify-center flex-column site-card-title-bg pt-2 pb-0">
            배터리
            <p class="text-caption ma-0">SOC</p>
          </v-card-title>
          <v-card-text class="pb-2 d-flex flex-column justify-center">
            <img class="ma-3" :src="batteryImage" alt height="122">
            <v-list dense class="mt-6 pb-0">
              <v-list-item-subtitle
                class="text-center text-h6"
              >{{BSC.BSC_Inform === '20.0' ? '충전': BSC.BSC_Inform === '24.0' ? '방전' : '대기'}}</v-list-item-subtitle>
              <v-list-item-title
                class="text-h4 font-weight-bold text-center pb-4 txt-blue"
              >{{BSC.BSC_P}} kW</v-list-item-title>
              <v-divider style="border-width: 2px;"></v-divider>
              <v-list-item>
                <v-list-item-content>SOC</v-list-item-content>
                <v-list-item-content class="justify-end">{{BSC.BSC_SOC}} %</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>SOH</v-list-item-content>
                <v-list-item-content class="justify-end">{{BSC.BSC_SOH}} %</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>배터리전압</v-list-item-content>
                <v-list-item-content class="justify-end">{{BSC.BSC_V}} V</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>배터리전류</v-list-item-content>
                <v-list-item-content class="justify-end">{{BSC.BSC_I}} A</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>렉최고온도</v-list-item-content>
                <v-list-item-content class="justify-end">{{BSC.BSC_HiModTemp}} ℃</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>렉최저온도</v-list-item-content>
                <v-list-item-content class="justify-end">{{BSC.BSC_LoModTemp}} ℃</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-text class="pt-0 d-flex flex-column mb-4">
            <v-card-subtitle class="pt-0">운행정보</v-card-subtitle>
            <img class="align-self-center" :src="trafficLight" alt>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="2">
        <v-card tile elevation="0" outlined>
          <v-card-title class="justify-center flex-column site-card-title-bg pt-2 pb-0">
            계통
            <p class="text-caption ma-0">현재발전량(유효전력)</p>
          </v-card-title>
          <v-card-text>
            <work-state-chart :value="GRID.GRID_PV_Capacity"></work-state-chart>
            <v-list dense class="mt-6">
              <v-list-item-subtitle class="text-center text-h6">&nbsp;</v-list-item-subtitle>
              <v-list-item-title
                class="text-h4 font-weight-bold text-center pb-4 txt-blue"
              >{{GRID.GRID_PV_Capacity}} kW</v-list-item-title>
              <v-divider style="border-width: 2px;"></v-divider>
              <v-list-item>
                <v-list-item-content>현재 발전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{GRID.GRID_PV_Capacity}} kW</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>당일 발전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{GRID.GRID_DAILY}} kWh</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>누적 발전량</v-list-item-content>
                <v-list-item-content class="justify-end">{{GRID.GRID_TOTAL}} kWh</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="2">
        <v-card max-height="700" tile elevation="0" outlined>
          <v-card-title class="justify-center site-card-title-bg pb-3">
            <p class="ma-0">공조설비</p>
          </v-card-title>
          <v-card-text v-scroll style="max-height: 630px" class="overflow-y-auto">
            <v-list tile dense v-for="(item, i) in CTH" :key="item.CTH_CODEID">
              <v-list-item-title class="title">배터리룸 온도/습도 {{i+1}}</v-list-item-title>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>온도</v-list-item-content>
                <v-list-item-content class="justify-end">{{item.CTH.CTH_Con1_Temp}} ℃</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>습도</v-list-item-content>
                <v-list-item-content class="justify-end">{{item.CTH.CTH_Con1_Humid}} %</v-list-item-content>
              </v-list-item>
            </v-list>

            <v-list tile dense v-for="item in HVAC" :key="item.HVAC_MODEL">
              <v-list-item-title class="title">{{item.HVAC.HVAC_DESCRIPTION}}</v-list-item-title>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>온도</v-list-item-content>
                <v-list-item-content class="justify-end">{{item.HVAC.HVAC_CurrentRoomTemperature}} ℃</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>설정온도</v-list-item-content>
                <v-list-item-content class="justify-end">{{item.HVAC.HVAC_SetTemperature}} ℃</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>운전모드</v-list-item-content>
                <v-list-item-content class="justify-end">{{item.HVAC.HVAC_Mode_Name}}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WorkStateChart from '@/components/monitoring/WorkStateChart'

export default {
  props: {
    essData: { type: [Object, Object], default: undefined }
  },
  components: {
    WorkStateChart
  },
  data() {
    return {
      item: [],
      EPCS: {
        EPCS_CDStatus_NAME: '충전',
        EPCS_ActPower: 366,
        EPCS_DayDisEnergy: 0,
        EPCS_DayChaEnergy: 1523,
        EPCS_TotChaEnergy: 2025.2,
        EPCS_TotDisEnergy: 14910.1
      },
      PVPCS: {
        PVPCS_Pac: 700,
        PVPCS_DailyP: 11111
      },
      GRID: {
        GRID_PV_Capacity: 500,
        GRID_DAILY: 34892.0,
        GRID_TOTAL: 380700.0
      },
      HVAC: [
        {
          HVAC: {
            HVAC_DESCRIPTION: 'ESS 에어컨 장비 1',
            HVAC_CurrentRoomTemperature: 36,
            HVAC_SetTemperature: 40,
            HVAC_Mode_Name: '운전'
          }
        }
      ],
      BSC: {
        BSC_Inform: '20.0',
        BSC_P: 100,
        BSC_SOC: 0,
        BSC_STATUS_COLOR: 'green'
      },
      WBS: {},
      CTH: [
        {
          CTH: {
            CTH_CODEID: 'aa',
            CTH_Con1_Temp: 36,
            CTH_Con1_Humid: 40
          }
        },
        {
          CTH: {
            CTH_CODEID: 'bb',
            CTH_Con1_Temp: 36,
            CTH_Con1_Humid: 40
          }
        }
      ],
      pvpcsChartOptions: createChartOption({ min: 0, max: 200, suffix: 'kW' }),
      epcsChartOptions: createChartOption({ min: 0, max: 200, suffix: 'kW' }),
      gridChartOptions: createChartOption({ min: 0, max: 200, suffix: 'kW' })
    }
  },
  watch: {
    essData() {
      this.initData()
    }
  },
  computed: {
    batteryImage() {
      let battery = this.BSC.BSC_SOC
      if (battery === 0) return require('@/assets/image/pc/bsc_00.png')
      else if (battery < 20) return require('@/assets/image/pc/bsc_01.png')
      else if (battery < 40) return require('@/assets/image/pc/bsc_02.png')
      else if (battery < 60) return require('@/assets/image/pc/bsc_03.png')
      else if (battery < 80) return require('@/assets/image/pc/bsc_04.png')
      else if (battery < 100) return require('@/assets/image/pc/bsc_05.png')
    },
    trafficLight() {
      let color = this.BSC.BSC_STATUS_COLOR
      if (color === 'red') return require('@/assets/image/light-red.jpg')
      else if (color === 'yellow') { return require('@/assets/image/light-yellow.jpg') } else return require('@/assets/image/light-green.jpg')
    }
  },
  mounted: function() {
    // this.initData()
  },
  methods: {
    initData() {
      if (this.essData.result !== 'noData') {
        this.item = this.essData

        if (this.item.essData.filter(d => d.EPCS).length !== 0) {
          this.EPCS = this.item.essData.filter(d => d.EPCS)[0].EPCS
          this.epcsChartOptions = createChartOption({
            min: 0,
            max: this.EPCS.EPCS_CAPA,
            suffix: 'kW'
          })
          this.epcsChartOptions.series[0].data = [
            parseInt(this.EPCS.EPCS_ActPower)
          ]
        }
        if (this.item.essData.filter(d => d.PVPCS).length !== 0) {
          this.PVPCS = this.item.essData.filter(d => d.PVPCS)[0].PVPCS
          this.pvpcsChartOptions = createChartOption({
            min: 0,
            max: this.PVPCS.PVPCS_CAPA,
            suffix: 'kW'
          })
          this.pvpcsChartOptions.series[0].data = [
            parseInt(this.PVPCS.PVPCS_Pac)
          ]
        }
        if (this.item.essData.filter(d => d.GRID).length !== 0) {
          this.GRID = this.item.essData.filter(d => d.GRID)[0].GRID
          this.gridChartOptions = createChartOption({
            min: 0,
            max: this.GRID.GRID_CAPA,
            suffix: 'kW'
          })
          this.gridChartOptions.series[0].data = [
            parseInt(this.GRID.GRID_PV_Capacity)
          ]
        }
        if (this.item.essData.filter(d => d.HVAC).length !== 0) {
          this.HVAC = this.item.essData.filter(d => d.HVAC)
        }
        if (this.item.essData.filter(d => d.BSC).length !== 0) {
          this.BSC = this.item.essData.filter(d => d.BSC)[0].BSC
        }
        if (this.item.essData.filter(d => d.WBS).length !== 0) {
          this.WBS = this.item.essData.filter(d => d.WBS)[0].WBS
        }

        // 배터리룸 온도/습도 추가 2019-10-10
        if (this.item.essData.filter(d => d.CTH).length !== 0) {
          this.CTH = this.item.essData.filter(d => d.CTH)
        }

        // CSS 조정 PC일 경우만
        let type = navigator.userAgent.toLocaleLowerCase()
        let cnt = this.CTH.length + this.HVAC.length
        if (
          cnt > 4 &&
          type.indexOf('android') < 0 &&
          type.indexOf('iphone') < 0
        ) {
          let rbHeight = 625 + 140 * (cnt - 4)
          let lbHeight = 701 + 140 * (cnt - 4)
          $('.result_box').css('min-height', rbHeight + 'px')
          $('.left_box').css('min-height', lbHeight + 'px')
        }
      }
    }
  }
}

function createChartOption({ min, max, suffix }) {
  return {
    chart: {
      type: 'solidgauge',
      height: 190,
      backgroundColor: '#31384b',
      color: '#64A7E6'
    },
    title: {
      text: null
    },
    pane: {
      center: ['50%', '50%'],
      size: '100%',
      startAngle: -90,
      endAngle: 90,
      background: {
        backgroundColor: '#EEE',
        innerRadius: '60%',
        outerRadius: '100%',
        shape: 'arc'
      }
    },
    tooltip: {
      enabled: false
    },
    // the value axis
    yAxis: {
      stops: [
        [0.3, '#DF5353'], // red
        [0.5, '#DDDF0D'], // yellow
        [0.7, '#55BF3B'] // green
      ],
      lineWidth: 0,
      minorTickInterval: null,
      tickAmount: 1,
      title: {
        y: -70,
        text: null
      },
      labels: {
        y: 16,
        style: {
          color: '#b7b7b7f7'
        }
      },
      min: min || 0, // 최소 값
      max: max || 200, // 최대 값
      tickPositioner: function() {
        return [min, max]
      }
    },
    plotOptions: {
      solidgauge: {
        dataLabels: {
          y: 5,
          borderWidth: 0,
          useHTML: true
        }
      }
    },
    credits: {
      enabled: false
    },
    series: [
      {
        type: 'solidgauge',
        data: [0],
        dataLabels: {
          format: `<div style = "text-align:center"><span style = "font-size:25px;color:
          white">{y}</span><br/>
          <span style = "font-size:12px;color:silver">${suffix}</span></div>`
        },
        tooltip: {
          valueSuffix: ' ' + suffix ? suffix : 'kw/h'
        }
      }
    ]
  }
}
</script>

<style lang="less" scoped>
.txt-blue {
  color: var(--v-txtblue-base);
}

.site-card-title-bg {
  background-color: #5c97cd;
  color: #fff;
}

.site-card-text-bg {
  background-color: #f0f0f0;
  color: #000;
}

.box_txt {
  color: white !important;
}
.pos_txt {
  color: #a5d5ff !important;
}
</style>
